import n from "react";
import { StandardLink as m } from "../link/standard-link.esm.js";
import "../link/span-link.esm.js";
import { TypographyComponent as p } from "../typography/typography-component.esm.js";
import { buildResponsiveSize as f } from "../utils/buildResponsiveSize.esm.js";
import { ratingCssConfig as a } from "./config.esm.js";
import { s } from "../rating.module-BNUHsKEH.mjs";
const c = (e) => {
  const [i] = f(e);
  if (i) {
    const t = {};
    return Object.keys(e).forEach((r) => {
      const o = e[r];
      o && (t[r] = a[o].fontSize);
    }), t;
  }
  return a[e].fontSize;
}, g = ({ link: e, size: i = "large", dataTestId: t, children: r }) => e ? /* @__PURE__ */ n.createElement(
  m,
  {
    className: s.rating__reviewLink,
    href: e,
    size: i,
    "data-testid": `${t}__review`,
    underline: !0
  },
  r
) : /* @__PURE__ */ n.createElement(
  p,
  {
    className: s.rating__review,
    size: c(i),
    type: "paragraph",
    "data-testid": `${t}__review`
  },
  r
);
g.displayName = "RatingReview";
export {
  g as RatingReview
};
